
import { isWeb } from '../src/utils/platformUtils'

/**
 * ✅ Sistema unificado usando DatabaseSingleton
 * TODAS las operaciones de BD deben usar este módulo
 */

const openDatabase = () => {
    if (isWeb()) {
        // Web: devolvemos façade mínima que no lanza errores
        return {
            transaction: (cb) => {
                const tx = { executeSql: (_s, _p, success) => success && success({}, { rows: { length: 0, item: () => null, _array: [] } }) }
                cb && cb(tx)
            },
            execSync: () => {},
            prepareSync: () => ({
                executeSync: () => ({ getAllSync: () => [], getFirstSync: () => null }),
                getAllSync: () => [],
                getFirstSync: () => null,
                finalizeSync: () => {},
            }),
        }
    }

    // ✅ NATIVE: Usar DatabaseSingleton directamente
    let dbInstance = null
    
    const getDbSync = async () => {
        if (!dbInstance) {
            // ✅ Usar getRealDatabase que maneja getInstance() + initializeTables() automáticamente
            const { getRealDatabase } = require('../database-sqlite/DatabaseSingleton')
            dbInstance = await getRealDatabase()
            console.log('✅ DatabaseSingleton inicializado correctamente vía getRealDatabase()')
        }
        return dbInstance
    }

    // Inicializar inmediatamente (sin await, se resuelve en background)
    getDbSync().catch(console.error)

    const facade = {
        execSync: (sql) => {
            if (!dbInstance) {
                console.warn('⚠️ DB no inicializada aún, esperando...')
                return
            }
            return dbInstance.execSync(sql)
        },
        prepareSync: (sql) => {
            if (!dbInstance) {
                console.warn('⚠️ DB no inicializada aún, esperando...')
                return {
                    executeSync: () => ({ getAllSync: () => [], getFirstSync: () => null }),
                    getAllSync: () => [],
                    getFirstSync: () => null,
                    finalizeSync: () => {},
                }
            }
            return dbInstance.prepareSync(sql)
        },
        transaction: (callback, errorCallback, successCallback) => {
            if (!dbInstance) {
                console.warn('⚠️ DB no inicializada aún para transaction')
                errorCallback && errorCallback(new Error('DB not initialized'))
                return
            }

            try {
                const tx = {
                    executeSql: (sql, params = [], success, error) => {
                        try {
                            const isSelect = /^\s*SELECT/i.test(sql)
                            if (isSelect) {
                                const stmt = dbInstance.prepareSync(sql)
                                const rowsArray = stmt.getAllSync(params)
                                stmt.finalizeSync()
                                const rows = {
                                    length: rowsArray.length,
                                    item: (i) => rowsArray[i],
                                    _array: rowsArray,
                                }
                                const result = { rows, rowsAffected: 0, insertId: undefined }
                                success && success(tx, result)
                            } else {
                                const stmt = dbInstance.prepareSync(sql)
                                stmt.executeSync(params)
                                stmt.finalizeSync()
                                const changes = dbInstance.prepareSync('SELECT changes() as rowsAffected').getFirstSync()
                                const lastId = /\bINSERT\b/i.test(sql)
                                    ? dbInstance.prepareSync('SELECT last_insert_rowid() as insertId').getFirstSync()
                                    : { insertId: undefined }
                                const result = {
                                    rows: { length: 0, item: () => undefined, _array: [] },
                                    rowsAffected: changes?.rowsAffected ?? 0,
                                    insertId: lastId?.insertId,
                                }
                                success && success(tx, result)
                            }
                        } catch (e) {
                            if (error) return error(tx, e)
                            throw e
                        }
                    },
                }
                callback && callback(tx)
                successCallback && successCallback()
            } catch (e) {
                errorCallback && errorCallback(e)
            }
        },
    }

    return facade
}

export const database_next = openDatabase()